import { gql } from '__generated__';

export default gql(`
  query GetTeamRegistrationCandidates($participant_id: ID!) {
    participant(id: $participant_id) {
      id
      registrations(include_inactive: true) {
        id
        ticket_number
        sequence
        status
        purchase {
          id
          active
        }
        ticket {
          id
          title
          position
          event {
            id
          }
        }
        time_slot {
          id
          start_date
          start_time
          multi_date
          title
        }
        team {
          id
          title
        }
      }
    }
  }
`);
